/** Checks if a path is an outbound link
 *
 * @param {string} path URL or path name
 * @returns {boolean}
 */
const isOutboundLink = path => {
  if (!path || typeof path !== 'string') return false;
  return /(fundera\.com\/|justbusiness\.com\/|^\/)(credit_cards|new_markets_products)\/\w+\/outbound_click/.test(
    path
  );
};

/** Checks if a path is a monetized link
 *
 * @param {string} path URL or path name
 * @returns {boolean}
 */
const isMonetizedLink = path => {
  if (!path || typeof path !== 'string') return false;
  return (
    isOutboundLink(path) ||
    /(fundera\.com\/|justbusiness\.com\/|^\/)(apply|apply-for-a-loan)($|\/|\?)/.test(
      path
    )
  );
};

module.exports = { isOutboundLink, isMonetizedLink };
